import { HostFamilyOlComment } from '../../../lib/types/models/host-family-ol-comment/host-family-ol-comment'
import { HostFamilyOlCommentRequest } from '../../../lib/types/models/host-family-ol-comment/host-family-ol-comment-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createHostFamilyOlComment = async (
  input: HostFamilyOlCommentRequest & { hostFamilyId: number }
) => {
  const { hostFamilyId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.hostFamilies.createHostFamilyOlComment.url, { hostFamilyId }))
    .post<HostFamilyOlComment, HostFamilyOlCommentRequest>(data)
}
